import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var GripHorizontal = createReactComponent("GripHorizontal", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "9",
  r: "1",
  key: "9w5l36"
}], ["circle", {
  cx: "19",
  cy: "9",
  r: "1",
  key: "fp9e2x"
}], ["circle", {
  cx: "5",
  cy: "9",
  r: "1",
  key: "1ov2e7"
}], ["circle", {
  cx: "12",
  cy: "15",
  r: "1",
  key: "wskt3z"
}], ["circle", {
  cx: "19",
  cy: "15",
  r: "1",
  key: "u07zys"
}], ["circle", {
  cx: "5",
  cy: "15",
  r: "1",
  key: "15pq1v"
}]]]);
export default GripHorizontal;